module.exports = __webpack_public_path__ + "media/fundraising_sim/fun_img-sp02-08d2adfc.png";